// src/utils/globalErrorTracker.js
import { logger } from "./logger";

export const setupGlobalErrorTracking = () => {
  // Use addEventListener so multiple handlers can coexist (e.g. Sentry, MUI)
  // Assignment (window.onerror = ...) overwrites any handler set by third-party libs
  window.addEventListener("error", (event) => {
    logger.error("Global JS Error", {
      message: event.message,
      url: event.filename,
      lineNo: event.lineno,
      columnNo: event.colno,
      stack: event.error?.stack,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    logger.error("Unhandled Promise Rejection", {
      reason: event.reason?.toString(),
      stack: event.reason?.stack,
    });
  });
};
